import React from "react";

const HeroSection = () => {
  return (
    <section className="bg-gradient-to-b from-violet-900 to-pink-800 text-white text-center py-20 px-4">
      <h2 className="text-3xl md:text-4xl font-bold mb-4">
        Start and Build Your Crypto Portfolio Here
      </h2>
      <p className="text-lg md:text-xl mb-6">
        Only at CryptoCap, you can build a good portfolio and learn best practices about cryptocurrency.
      </p>
      <button className="bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600">
        Get Started
      </button>
    </section>
  );
};

export default HeroSection;